import { render, staticRenderFns } from "./PrizeDrawList.vue?vue&type=template&id=dee382f8"
import script from "./PrizeDrawList.vue?vue&type=script&lang=js"
export * from "./PrizeDrawList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports